// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ButtonsV5 = require("../../v5/common/Components/ButtonsV5.bs.js");
let RelayRuntime = require("relay-runtime");
let SystemMessages = require("../systemMessages/SystemMessages.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UseNewVersionNoticeQuery_graphql = require("../../__generated__/UseNewVersionNoticeQuery_graphql.bs.js");
let UseNewVersionNoticeUpdatableQuery_graphql = require("../../__generated__/UseNewVersionNoticeUpdatableQuery_graphql.bs.js");

let convertVariables = UseNewVersionNoticeQuery_graphql.Internal.convertVariables;

let convertResponse = UseNewVersionNoticeQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UseNewVersionNoticeQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UseNewVersionNoticeQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UseNewVersionNoticeQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UseNewVersionNoticeQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UseNewVersionNoticeQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UseNewVersionNoticeQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UseNewVersionNoticeQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let UpdatableQuery = {
  Types: undefined,
  readUpdatableQuery: UseNewVersionNoticeUpdatableQuery_graphql.readUpdatableQuery
};

function useNewVersionNotice() {
  let match = use(undefined, "store-only", undefined, undefined);
  let hasNotifiedAboutNewFrontendCodeVersion = match.hasNotifiedAboutNewFrontendCodeVersion;
  let codeVersionOfFrontendBundle = match.codeVersionOfFrontendBundle;
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  React.useEffect(() => {
    let match = process.env.NEXT_PUBLIC_BUILD_ID;
    if (match !== undefined && codeVersionOfFrontendBundle === undefined) {
      RelayRuntime.commitLocalUpdate(environment, store => {
        let updatableQuery = UseNewVersionNoticeUpdatableQuery_graphql.readUpdatableQuery(store, undefined);
        updatableQuery.updatableData.codeVersionOfFrontendBundle = match;
        updatableQuery.updatableData.hasNotifiedAboutNewFrontendCodeVersion = false;
      });
    }
  }, [codeVersionOfFrontendBundle]);
  React.useEffect(() => {
    if (hasNotifiedAboutNewFrontendCodeVersion !== undefined && hasNotifiedAboutNewFrontendCodeVersion) {
      return;
    }
    if (codeVersionOfFrontendBundle === undefined) {
      return;
    }
    let intervalId = setInterval(() => {
      let run = async () => {
        let res = await globalThis.fetch("/api/build-id");
        let dict = await res.json();
        if (typeof dict !== "object" || dict === null || Array.isArray(dict)) {
          return;
        }
        let match = dict["buildId"];
        if (typeof match === "string" && match !== codeVersionOfFrontendBundle) {
          RelayRuntime.commitLocalUpdate(environment, store => {
            let updatableQuery = UseNewVersionNoticeUpdatableQuery_graphql.readUpdatableQuery(store, undefined);
            updatableQuery.updatableData.codeVersionOfFrontendBundle = codeVersionOfFrontendBundle;
            updatableQuery.updatableData.hasNotifiedAboutNewFrontendCodeVersion = true;
          });
          return addMessage(SystemMessages.Message.make("updated-code-notice", "info", "A new version of TAN is available. Please refresh this page to upgrade", 0, param => JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
            onClick: param => {
              window.location.reload();
            },
            children: "Refresh"
          }), false));
        }
      };
      run();
    }, 300000);
    return () => {
      clearInterval(intervalId);
    };
  }, [
    codeVersionOfFrontendBundle,
    hasNotifiedAboutNewFrontendCodeVersion
  ]);
}

exports.Query = Query;
exports.UpdatableQuery = UpdatableQuery;
exports.useNewVersionNotice = useNewVersionNotice;
/* use Not a pure module */
